import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { AuthContext } from "../context/AuthContext";

const API_URL = "https://wip.technicalcreatives.lk/api/users.php";

function Login() {
  const [identifier, setIdentifier] = useState(""); 
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Send request with action in query string
      const res = await axios.post(`${API_URL}?action=login`, {
        identifier,
        password,
      });
      console.log("API Response:", res.data);
      if (res.data.success && res.data.token) {
        // Save token & user info in context & localStorage
        localStorage.setItem("token", res.data.token);
        login(res.data);
        navigate("/dashboard");
      } else {
        alert(res.data.message || "Login failed");
      }
    } catch (error) {
      // console.error(error);
      console.error("Login API error:", error.response?.data || error.message);
      alert("Invalid credentials or server error");
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left - Login Form */}
      <div className="w-full md:w-1/2 flex items-center justify-center bg-white px-8 py-16">
        <div className="max-w-md w-full">
          <div className="mb-8">
            <img src="/images/logo.jpg" alt="Logo" className="h-20 mb-4" />
            <h2 className="text-3xl font-bold text-gray-900">Welcome!</h2>
            <p className="text-sm text-gray-500 mt-2">Please enter your details</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Email Address</label>
              <input
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                className="w-full px-4 py-2 mt-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Password</label>
              <div className="relative">
                <input
                  type={visible ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2 pr-10 mt-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
                <button
                  type="button"
                  onClick={() => setVisible(!visible)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                >
                  {visible ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between text-sm">
              <label className="flex items-center">
                <input type="checkbox" className="mr-2" />
                Remember me
              </label>
              <a href="/reset-password" className="text-blue-600 hover:underline">
                Forgot password
              </a>
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
            >
              Sign in
            </button>
          </form>

          <p className="text-sm text-center text-gray-600 mt-4">
            Don’t have an account?{" "}
            <a href="/tc-wip-board" className="text-blue-600 hover:underline">
              Sign up
            </a>
          </p>
        </div>
      </div>

      {/* Right - Illustration */}
      <div className="hidden md:block w-1/2 bg-blue-100 relative">
        <img
          src="/images/task.png"
          alt="login"
          className="absolute top-1/2 left-1/2 object-cover w-[500px] h-[500px] transform -translate-x-1/2 -translate-y-1/2"
        />
      </div>
    </div>
  );
}

export default Login;